

































































































































































































































import PartnerDetail from '@/components/partner/PartnerDetail.vue';
import {Vue, Component} from 'vue-property-decorator';
import {htmlRestore, getCountryName, getBankName} from '@/utils/formatUtils';
@Component({
  components: {PartnerDetail}
})
export default class PartnerContract extends Vue {
  private partnerNo: string = '';
  private showInfo: any = null;

  private async created() {
    this.partnerNo = this.$route.query.partnerNo as string;
    const request: any = {
      pathParams: {
        partnerNo: this.partnerNo
      }
    };
    let {data} = await this.$api.getPartnersActivePartnerNo(request);
    this.showInfo = {
      countryCd: data.partner.countryCode,
      countryName: getCountryName(data.partner.countryCode),
      officeZipCode: data.partner.office.zipCode,
      officeStreetAddress1: htmlRestore(data.partner.office.address),
      officeStreetAddress2: htmlRestore(data.partner.office.detailAddress),
      officeJibunAddress1: htmlRestore(data.partner.office.jibun),
      officeJibunAddress2: htmlRestore(data.partner.office.jibunDetail),
      officeCity: htmlRestore(data.partner.office.city),
      officeStateOrRegion: htmlRestore(data.partner.office.stateOrRegion),
      partnerNo: data.partner.partnerNo,
      partnerName: data.partner.partnerName,
      companyName: data.partner.companyName,
      businessRegistrationNo: data.partner.business.registrationNo,
      sellerTaxationType: data.partner.sellerTaxationType,
      sellerTaxationTypeLabel: this.$t(`PARTNER_SELLER_TAXATION_TYPE_${data.partner.sellerTaxationType}`),
      representativeName: data.partner.representative.name,
      businessType: data.partner.business.type,
      businessCondition: data.partner.business.condition,
      representPhoneNo: data.partner.representative.phoneNo,
      faxNo: data.partner.faxNo,
      representEmail: data.partner.representative.email,
      onlineMarketingBusinessDeclarationNo: data.partner.business.onlineMarketingDeclarationNo,
      settlementManagerName: data.partner.settlementManager.name,
      settlementManagerEmail: data.partner.settlementManager.email,
      settlementManagerPhoneNo: data.partner.settlementManager.phoneNo,
      tradeBank: data.partner.tradeBank.bank,
      tradeBankName: getBankName(data.partner.tradeBank.bank),
      tradeBankAccount: data.partner.tradeBank.account,
      tradeBankDepositoryName: data.partner.tradeBank.depositorName,
      adminId: data.admin.adminId || '',
      adminEmail: data.admin.contactInfo.email,
      adminName: data.admin.adminName,
      adminJobPosition: data.admin.jobPositionName,
      adminDepartment: data.admin.departmentName,
      adminJobDuty: data.admin.jobDutyName,
      adminPhoneNo: data.admin.contactInfo.phoneNo,
      adminMobileNo: data.admin.contactInfo.mobileNo
    };
  }
}
